import React, { Component } from "react";
import ReactDOM from 'react-dom';
import CircularProgress from '@mui/material/CircularProgress';

class LoadingIndicator extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            loadingMessage: ''
        };

        this.loadingIndicatorChanged = this.loadingIndicatorChanged.bind(this);


    }

    componentDidMount() {
        window.addEventListener('loading-indicator-change', this.loadingIndicatorChanged);
    }

    loadingIndicatorChanged(e) {
        this.setState({ isLoading: e.detail.isLoading });
        this.setState({ loadingMessage: (e.detail.loadingMessage === null ? '' : e.detail.loadingMessage) });
    }

    static showLoading(message) {
        window.dispatchEvent(new CustomEvent('loading-indicator-change', { detail: { loadingMessage: message, isLoading: true } }));
    }

    static hideLoading() {
        window.dispatchEvent(new CustomEvent('loading-indicator-change', { detail: { loadingMessage: '', isLoading: false } }));
    }

    render() {

        if (!this.state.isLoading) {
            return null;
        }
        return (
            <div className={"loading_container"}>
                <div>
                    <CircularProgress color="secondary" />

                    <div className={"loading_container_message"}>{this.state.loadingMessage}</div>
                </div>
            </div>);
    }
}
export default LoadingIndicator;